var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-between align-items-start" },
    [
      _c(
        "material-input",
        {
          ref: "input",
          staticClass: "form-group-material-no-label",
          attrs: {
            placeholder: "XXX XXX XXX",
            "hidden-label": true,
            label: _vm.label,
            "label-for": _vm.labelValue,
          },
        },
        [
          _c("input", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: {
                  mask: "999 999 999",
                  placeholder: "XXX XXX XXX",
                  greedy: false,
                  showMaskOnHover: false,
                },
                expression:
                  "{\n        mask: '999 999 999',\n        placeholder: 'XXX XXX XXX',\n        greedy: false,\n        showMaskOnHover: false\n      }",
              },
            ],
            key: _vm.name,
            ref: "targetInput",
            staticClass: "form form-control fe-num-field ssn-field",
            class: _vm.className,
            attrs: {
              id: _vm.labelValue,
              name: _vm.name,
              pattern: ".{11,11}",
              type: "text",
              placeholder: "XXX XXX XXX",
              maxlength: "11",
              disabled: _vm.disabled,
              tabindex: _vm.tabindex,
              obfuscated: _vm.obfuscatedSIN,
            },
            domProps: { value: _vm.inputVal },
            on: {
              change: function ($event) {
                return _vm.handleChange($event.target.value)
              },
              keypress: _vm.onlyNumbers,
            },
          }),
          _vm._v(" "),
          _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
          _vm._v(" "),
          _c("span", { staticClass: "bar" }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.shouldShowToggle
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "b-tooltip",
                  rawName: "v-b-tooltip.top",
                  value: _vm.tooltipTitle,
                  expression: "tooltipTitle",
                  modifiers: { top: true },
                },
              ],
              staticClass: "col pr-0 order-lg-2 text-right order-1",
              on: { click: _vm.toggleFullSIN },
            },
            [
              _vm.loading
                ? _c("div", { staticClass: "ld ld-ring ld-spin-fast mini" })
                : _c("icon", {
                    staticClass: "show-sin text-primary clickable",
                    attrs: { name: _vm.showSinIconName },
                  }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }